import { getKycVelocity } from "api/graphQL_kycvelocity";
import { useEffect, useState, useContext } from "react";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import KycTable from "./components/KycList";
import CreateKycVelocityModal from "./components/CreateKycVelocityModal";

export interface KycRowObj {
  id: any;
  velocityId: any;
  country: any;
  transactionLimit: any;
  maxAmountPerTransaction: any;
  minAmountPerTransaction: any;
  maxTransactionAmount: any;
  paymentMethods: any;
  createdAt: any;
}

const KycVelocity = () => {
  const [page, setPage] = useState<number>(1);
  const [kycVelocity, setKycVelocity] = useState<KycRowObj[]>([]);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { singleRoleData, setFilter, filter } = useContext(ClientContext);
  const location = useLocation();
  const [localFilters, setLocalFilters] = useState<any>({});
  const [clearClicked, setClearClick] = useState(0);

  const fetchKycVelocity = async () => {
    let finalSearchText = "";
    if (location.state?.search) {
      finalSearchText = location.state.search;
      window.history.replaceState({}, document.title);
    } else {
      finalSearchText = searchTexts;
    }
    if (pageSize === null || pageSize === undefined) return;
    setIsLoading(true);
    getKycVelocity({ page, per_page: pageSize, searchTexts: finalSearchText })
      .then((data: any) => {
        if (data.status === "Error") {
          setKycVelocity([]); setTotalPage(1); setTotalItems(0); setCurrentPage(1);
        } else {
          setKycVelocity(data?.[0]);
          setTotalPage(data?.[1].total_pages);
          setTotalItems(data?.[1].total_items);
          setCurrentPage(data?.[1].current_page);
        }
      })
      .catch(() => setKycVelocity([]))
      .finally(() => setIsLoading(false));
  };

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1); setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  useEffect(() => { fetchKycVelocity(); }, [page, pageSize, searchTexts, clearClicked]);
  useEffect(() => { setPageSize(50); }, [searchTexts]);

  const onClearClick = () => setClearClick((prev) => prev + 1);

  return (
    <div className="kyc-root">
      {/* Page header */}
      <div className="kyc-page-header">
        <div className="kyc-title-block">
          <div className="kyc-page-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
              <path d="M16 11l2 2 4-4" strokeWidth="2.5"/>
            </svg>
          </div>
          <div>
            <h1 className="kyc-heading">KYC Velocity</h1>
            <p className="kyc-sub">Manage KYC verification limits by country and transaction type</p>
          </div>
        </div>
        {singleRoleData?.[0]?.kyc_velocity?.value?.add_kyc_velocity && (
          <div className="kyc-page-actions">
            <CreateKycVelocityModal fetchKycVelocity={fetchKycVelocity} roleData={singleRoleData} />
          </div>
        )}
      </div>

      <KycTable
        clients={undefined}
        tableData={kycVelocity}
        fetchKycVelocity={fetchKycVelocity}
        isLoading={isLoading}
        roleData={singleRoleData}
        onValueChange={serchboxValueChange}
        page={page}
        setPage={setPage}
        totalpage={totalpage}
        totalItems={totalItems}
        currentPage={currentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        setLocalFilters={setLocalFilters}
        filterData={fetchKycVelocity}
        localFilters={localFilters}
        filter={filter}
        setFilter={setFilter}
        setClearClick={onClearClick}
      />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .kyc-root { font-family:'Plus Jakarta Sans',sans-serif; display:flex; flex-direction:column; gap:20px; }
        .kyc-page-header { display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:16px; }
        .kyc-title-block { display:flex; align-items:center; gap:14px; }
        .kyc-page-icon { width:44px; height:44px; border-radius:12px; background:linear-gradient(135deg,#fdf4ff,#fae8ff); border:1.5px solid #e9d5ff; display:flex; align-items:center; justify-content:center; color:#7c3aed; flex-shrink:0; }
        .kyc-heading { font-size:20px; font-weight:800; color:#0f172a; letter-spacing:-0.4px; margin-bottom:2px; line-height:1.2; }
        .kyc-sub { font-size:13px; color:#94a3b8; font-weight:500; }
        .kyc-page-actions { display:flex; gap:10px; align-items:center; }
      `}</style>
    </div>
  );
};

export default KycVelocity;